// Meet Again 🌙: what this device remembers about each pair, so a person can tell
// them apart. Kept in localStorage only: the server never sees names or notes.
// The server's list (ids and dates) decides which pairs still exist.

export type MeetLocal = {
  name: string;                     // their temporary name in that chat
  role: 'VENT' | 'LISTEN' | null;   // your role in that chat
  date: string;                     // ISO date the pair was made
  note: string;                     // your own short note, up to 40 characters
};
export type MeetPairInfo = { id: string; createdAt: string; lastMetAt: string };

export const MEET_NOTE_MAX = 40;
const KEY = 'zuzu_meet_again';

export const loadMeetLocal = (): Record<string, MeetLocal> => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || '{}');
    return v && typeof v === 'object' ? v : {};
  } catch {
    return {};
  }
};

export const saveMeetLocal = (all: Record<string, MeetLocal>) => {
  try { localStorage.setItem(KEY, JSON.stringify(all)); } catch { /* private mode */ }
};

const shortDate = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(+d) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};

// "the guitar person", or "Sunny Fox · 3 Oct" when there is no note.
export const meetLabel = (local: MeetLocal | undefined, pair?: MeetPairInfo) =>
  local?.note.trim() || (local ? `${local.name} · ${shortDate(local.date)}` : `Someone · ${shortDate(pair?.createdAt ?? '')}`);

// "3 Oct · you listened" (shown under a note).
export const meetDetail = (local: MeetLocal | undefined, pair?: MeetPairInfo) => {
  const date = shortDate(local?.date ?? pair?.createdAt ?? '');
  if (!local) return date;
  const role = local.role === 'VENT' ? 'you vented' : local.role === 'LISTEN' ? 'you listened' : '';
  return [local.note.trim() ? local.name : '', date, role].filter(Boolean).join(' · ');
};
